<template>
  <div>
    <div class="">
      <b-tabs lazy fill Justified v-model="activeTab" @input="changeTab">
        <b-tab title="Yêu cầu Combo đối tác">
          <Agent />
        </b-tab>
        <b-tab title="Yêu cầu Combo MC tingbox">
          <AgentTingBox v-if="dataPermission.includes(AgentTingBoxPermission)" />
          <div v-else>
            <h5 class="text-center mt-5">Bạn không có quyền truy cập</h5>
          </div>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>
<script>
  import Agent from './listAgent.vue'
  import AgentTingBox from './listTingbox.vue'
  import { mapGetters } from 'vuex'
  import { showMess } from '../../../config/utils'

  const AgentTingBoxPermission = 'CNPS_SCON_REQUEST_COMBO_VIEW'

  export default {
    name: 'QRTABS',
    data() {
      return {
        AgentTingBoxPermission,
        activeTab: this.$route.query.tab ? Number(this.$route.query.tab) : 0,
      }
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    watch: {
      '$route.query.tab'(val) {
        this.activeTab = val ? Number(val) : 0
        if (this.activeTab === 1 && !this.dataPermission.includes(AgentTingBoxPermission)) {
          showMess(
            this,
            'Thông báo',
            'Bạn không có quyền truy cập tab này',
            'danger',
            'b-toaster-top-right',
            0
          )
        }
      },
    },
    methods: {
      changeTab(tab) {
        this.$router.replace({ query: { tab } })
      },
    },
    components: { Agent, AgentTingBox },
  }
</script>
